export default __webpack_public_path__ + "static/media/Printaform_home_main.21ce84e3.jpg";